import React from 'react';
import { motion } from 'framer-motion';
import { Book, Droplets, Wine, Plus } from 'lucide-react';
const bonuses = [{
  icon: <Book className="text-bbq-gold" size={24} data-id="element-75" />,
  title: 'Ebook: El Código Secreto del Asado Chileno',
  value: '$27.000',
  desc: 'La biblia de 60 páginas.'
}, {
  icon: <Droplets className="text-bbq-gold" size={24} data-id="element-76" />,
  title: 'Bonus 2: El ABC de la Salmuera Masterclass',
  value: '$7.500',
  desc: 'El secreto de la suavidad.'
}, {
  icon: <Wine className="text-bbq-gold" size={24} data-id="element-77" />,
  title: 'Bonus 3: Guía de Vinos de Súper',
  value: '$12.990',
  desc: 'El maridaje perfecto.'
}];
export function OfferSection() {
  return <section id="offer" className="bg-bbq-dark py-24 px-4 relative overflow-hidden" data-id="element-78">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[600px] bg-bbq-ember/10 blur-[120px] rounded-full pointer-events-none" data-id="element-79"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-80">
        <div className="text-center mb-16" data-id="element-81">
          <h2 className="text-3xl md:text-5xl font-display font-bold text-white uppercase tracking-wide mb-4" data-id="element-82">
            El Sistema Completo
          </h2>
          <p className="text-xl text-gray-400" data-id="element-83">
            Al comprar hoy, no solo te llevas el Ebook Principal...
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-84">
          {/* Image Column */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-85">
            <div className="absolute inset-0 bg-gradient-to-tr from-bbq-gold/20 to-transparent rounded-2xl blur-2xl" data-id="element-86"></div>
            <img src="https://cdn.magicpatterns.com/uploads/3uZftr2R2cX8Bfgs44MaCz/oferta_asado.jpg" alt="Pack El Código del Asado Chileno" className="relative z-10 w-full rounded-2xl shadow-2xl border border-white/10" data-id="element-87" />
          </motion.div>

          {/* Bonuses Column */}
          <div className="space-y-4" data-id="element-88">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: 50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`flex items-start gap-4 p-4 rounded-lg border ${index === 0 ? 'bg-bbq-surface border-bbq-gold/30' : 'bg-bbq-surface/50 border-white/5'}`} data-id="element-89">
                <div className="mt-1 bg-bbq-dark p-2 rounded-md border border-white/5" data-id="element-90">
                  {bonus.icon}
                </div>
                <div data-id="element-91">
                  <h4 className="text-lg font-bold text-white flex flex-wrap items-center gap-2" data-id="element-92">
                    {bonus.title}
                    <span className="text-sm font-normal text-gray-500 line-through" data-id="element-93">
                      (Valor: {bonus.value})
                    </span>
                  </h4>
                  <p className="text-gray-400 text-sm" data-id="element-94">{bonus.desc}</p>
                </div>
              </motion.div>)}

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.7
          }} className="mt-8 p-6 bg-gradient-to-r from-bbq-surface to-bbq-dark border border-bbq-gold/20 rounded-xl text-center" data-id="element-95">
              <p className="text-gray-400 uppercase tracking-widest text-sm mb-1" data-id="element-96">
                Valor Total
              </p>
              <p className="text-3xl font-display font-bold text-white line-through decoration-bbq-urgency decoration-4 opacity-70" data-id="element-97">
                $65.850 CLP
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}